<div class="card p-3 mb-3"
  [ngClass]="(type === 'measure' && done) ? 'valid' : (type === 'measure' && !done) ? 'invalid' : ''">
  <!-- <div class="card p-3 mb-3" [ngClass]="done ? 'valid' : 'invalid'"> -->

  <!-- only choice THSarabun use own scss -->
  <div class="container py-3">
    <h4 class="my-3 text-left">
      <span *ngIf="isAutoNumber"
        [ngClass]="font === 'arial' ? 'Arial' : font === 'times-new-roman' ? 'TimeNewRoman' : font === 'calibri' ? 'Calibri' : font === 'comic-sans-ms' ? 'ComicSansMS' : font === 'th-sarabun' ? 'THsarabun-Header' : font === 'K2D' ? 'K2D' : ''">{{ multipleChoice.NUMBER }}.
        {{ multipleChoice.VALUE[0].question }}</span>

      <span *ngIf="!isAutoNumber"
        [ngClass]="font === 'arial' ? 'Arial' : font === 'times-new-roman' ? 'TimeNewRoman' : font === 'calibri' ? 'Calibri' : font === 'comic-sans-ms' ? 'ComicSansMS' : font === 'th-sarabun' ? 'THsarabun-Header' : font === 'K2D' ? 'K2D' : ''">{{ questionNumber }}.
        {{ multipleChoice.VALUE[0].question }}</span>
      <!-- {{ multipleChoice.NUMBER }}. {{ multipleChoice.VALUE[0].question }} -->
    </h4>

    <div *ngIf="multipleChoice.VALUE[0].media.file_url">
      <div class="d-flex justify-content-center">

        <!-- image -->
        <img *ngIf="multipleChoice.VALUE[0].media.media_type === 'image'" [src]="multipleChoice.VALUE[0].media.file_url"
          alt="" class="img-fluid my-3 mx-auto d-block" style="width: 855px;"><br>

        <!-- video -->
        <plyr *ngIf="multipleChoice.VALUE[0].media.media_type === 'vdo'" class="plyr" id="video"
          style="display: block; width: 855px;" plyrTitle="Video 1" [plyrSources]="videoSources"
          (plyrInit)="player = $event;" (plyrPlay)="played($event)" (plyrEnded)="vdoEnable(time_again)"
          (plyrTimeUpdate)="currentvdoTime()">
        </plyr>

        <!-- sound -->
        <div *ngIf="multipleChoice.VALUE[0].media.media_type === 'sound'">
          <mat-card class="d-flex justify-content-between mb-3"
            style="width: 240px; border-radius: 30%; border-top-left-radius: 30px; border-bottom-left-radius: 30px; border-top-right-radius: 30px; border-bottom-right-radius: 30px; padding: 5px 5px 5px 5px;">

            <a *ngIf="audioBtnStatus" style="padding: 5px 10px 5px 10px;" (click)="playAudio(multipleChoice.ID)">
              <img src="assets/play-button-w.png" style="width: 30px;" alt="">
            </a>
            <a *ngIf="!audioBtnStatus" disabled style="padding: 5px 10px 5px 10px;">
              <img src="assets/play-button-disabled.png" style="width: 30px;" alt="">
            </a>
            <h6 style="margin-top: 12px; margin-right: 17px">
              <span
                [ngClass]="font === 'arial' ? 'Arial' : font === 'times-new-roman' ? 'TimeNewRoman' : font === 'calibri' ? 'Calibri' : font === 'comic-sans-ms' ? 'ComicSansMS' : font === 'th-sarabun' ? 'THSarabun' : font === 'K2D' ? 'K2D' : ''">{{ audCurrentTime | number: '1.2-2' }}
                /
                {{ multipleChoice.VALUE[0].media.duration / 100 | number: '1.2-2' }}</span>
            </h6>
          </mat-card>
          <p class="text-primary text-center" *ngIf="!unlimit"
            [ngClass]="font === 'arial' ? 'Arial' : font === 'times-new-roman' ? 'TimeNewRoman' : font === 'calibri' ? 'Calibri' : font === 'comic-sans-ms' ? 'ComicSansMS' : font === 'th-sarabun' ? 'THSarabun' : font === 'K2D' ? 'K2D' : ''">
            *เล่นได้อีก {{ time_again }} ครั้ง</p>
          <audio [id]="multipleChoice.ID" type="audio/mp3" (ended)="auEnable(time_again)"
            (timeupdate)="currentaudTime(multipleChoice.ID)">
            <source [src]="multipleChoice.VALUE[0].media.file_url">
          </audio>
        </div>

      </div>

      <!-- video play button -->
      <div *ngIf="multipleChoice.VALUE[0].media.media_type === 'vdo'" style="margin-bottom: 50px;">
        <div class="border mb-3"
          style="border-bottom-left-radius: 30px; border-bottom-right-radius: 30px; padding: 5px 5px 5px 5px;">
          <div class="row">
            <div class="col-1" style="margin: 6px 0 6px 0;">
              <a *ngIf="videoBtnStatus" style="padding: 5px 10px 5px 10px;" (click)="playVideo()">
                <img src="assets/play-button-w.png" style="width: 30px;" alt="">
              </a>
              <a *ngIf="!videoBtnStatus" disabled style="padding: 5px 10px 5px 10px;">
                <img src="assets/play-button-disabled.png" width="30px" alt="">
              </a>
            </div>
            <div class="col-5">
              <h6 style="margin: 11px 0px 0px 20px;">
                <span
                  [ngClass]="font === 'arial' ? 'Arial' : font === 'times-new-roman' ? 'TimeNewRoman' : font === 'calibri' ? 'Calibri' : font === 'comic-sans-ms' ? 'ComicSansMS' : font === 'th-sarabun' ? 'THSarabun' : font === 'K2D' ? 'K2D' : ''">{{ vdoCurrentTime | number: '1.2-2' }}
                  / {{ multipleChoice.VALUE[0].media.duration / 100 | number: '1.2-2' }}</span>
              </h6>
            </div>
            <div class="col-6">
              <p class="text-primary text-right" style="margin: 12px 10px 0 0;" *ngIf="!unlimit"
                [ngClass]="font === 'arial' ? 'Arial' : font === 'times-new-roman' ? 'TimeNewRoman' : font === 'calibri' ? 'Calibri' : font === 'comic-sans-ms' ? 'ComicSansMS' : font === 'th-sarabun' ? 'THSarabun' : font === 'K2D' ? 'K2D' : ''">
                *เล่นได้อีก {{ time_again }} ครั้ง
              </p>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div *ngIf="!type">
      <mat-radio-group class="mt-3">

        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12" *ngFor="let item of multipleChoice.VALUE[0].choices; let i = index">
            <mat-radio-button [value]="item.choice_id" class="mt-3">
              <div *ngIf="item.media.file_url" class="card mb-3 pt-3 border-dark">
                <img mat-card-image [src]="item.media.file_url" alt="" class="img-fluid mx-auto d-block"
                  style="width: 300px; height: 150px; object-fit: contain; margin-top: 0px; margin-bottom: 0px;">
                <br>
              </div>
              <span style="white-space: normal;"
                [ngClass]="font === 'arial' ? 'Arial' : font === 'times-new-roman' ? 'TimeNewRoman' : font === 'calibri' ? 'Calibri' : font === 'comic-sans-ms' ? 'ComicSansMS' : font === 'th-sarabun' ? 'THsarabun-choice' : font === 'K2D' ? 'K2D' : ''">
                {{ i+1 }}. {{ item.choice_detail }}</span>
            </mat-radio-button>
          </div>
        </div>

      </mat-radio-group>
    </div>

    <div *ngIf="type === 'measure' || type === 'research'">

      <mat-radio-group class="mt-3" [(ngModel)]="choice" (change)="patchVal(choice)">

        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12" *ngFor="let item of multipleChoice.VALUE[0].choices; let i = index">
            <mat-radio-button [value]="item.choice_id" class="mt-3">
              <div *ngIf="item.media.file_url" class="card mb-3 pt-3 border-dark">
                <img mat-card-image [src]="item.media.file_url" alt="" class="img-fluid mx-auto d-block"
                  style="width: 300px; height: 150px; object-fit: contain; margin-top: 0px; margin-bottom: 0px;">
                <br>
              </div>
              <span style="white-space: normal;"
                [ngClass]="font === 'arial' ? 'Arial' : font === 'times-new-roman' ? 'TimeNewRoman' : font === 'calibri' ? 'Calibri' : font === 'comic-sans-ms' ? 'ComicSansMS' : font === 'th-sarabun' ? 'THsarabun-choice' : font === 'K2D' ? 'K2D' : ''">
                {{ i+1 }}. {{ item.choice_detail }}
              </span>
            </mat-radio-button>
          </div>
        </div>

      </mat-radio-group>

    </div>

  </div>

</div>
